import React, { Component } from 'react';
import './Login.css';
import { toast, ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
import { withTranslation } from "react-i18next";

class LostPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        };
        this.onChange = this.onChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this); // Binding the sendEmail method
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    sendEmail(e) {
        e.preventDefault(); // Prevent the default form submission behavior

        // Show loading indicator
        toast.info("Invio della richiesta in corso...", { autoClose:1000 });

        // Send email using EmailJS
        emailjs.sendForm('service_u317szf', 'template_4appmns', e.target, 'Xl4cHzs5_rTnbe391')
            .then((result) => {
                // Display success message
                toast.success("Richiesta inviata! Ti contatteremo a breve", { autoClose: 2000 });

                // Optionally reset the form here if desired
                e.target.reset();
                this.setState({ email: '' }); // Clear email state
            }, (error) => {
                console.error(error.text);
                // Display error message
                toast.error("Si è verificato un errore durante l'invio della richiesta. Riprova più tardi.", { autoClose: 2000 });
            });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="main-wrapper-login">
                <div className="tools-wrapperS1-login">
                    <div className="login-block">

                        <ToastContainer /> {/* Include ToastContainer for notifications */}
                        <h3 className="preview-title">{t('pages.login.l7')} </h3>


                        <div className="Principal-login">
                            <div className="login-block">
                                <form onSubmit={this.sendEmail}> {/* Use this.sendEmail */}

                                    <div>
                                        <input
                                            type="email"
                                            placeholder="Enter your email"
                                            name="email"
                                            value={this.state.email}
                                            onChange={this.onChange} // Corrected onChange usage
                                            required
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn-block"
                                        style={{ maxWidth: '300px' }}
                                    >
                                        {t('pages.register.r5')}
                                    </button>
                                    <div className="additional-options">
                                        <div>
                                            <p>{t('pages.register.r2')}</p>
                                            <a href="/login" className="forgot-password-link">
                                                {t('pages.register.r3')}
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
              </div>

        );
    }
}
export default withTranslation()(LostPassword);
